import request from '@/utils/request'
const apiPath = '/course/courseCreditLevel'
import { downloadBlob } from '@/utils/download'
const courseCreditLevelApi = {
  /**
   * 新增【学分等级配置】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【学分等级配置】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【学分等级配置】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 
   * 查看【学分等级配置】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【学分等级配置】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  batchState(data) {
    return request.post(apiPath + '/batchState', data, { isFormData: 1 })
  },
}
export default courseCreditLevelApi
